import { SelectInput } from "src/app/shared/dropdown/shared/select-input.class";

export enum ErrorType {
    Unknown,
    ChannelError,
    PixelError,
    VoltageError,
    FuelWarning,
    SystemStatusFuelcell,
    STMInput,
    ConnectionError = 8,

 /*    LampError */
}

export function getErrorTypeString(type: ErrorType): string {
    switch (type) {
        case ErrorType.ChannelError:
            return 'Kanalfehler';
        case ErrorType.PixelError:
            return 'Pixel Fehler';
        case ErrorType.VoltageError:
            return 'Spannungsfehler';
        case ErrorType.FuelWarning:
            return 'Brennstoffwarnung';
        case ErrorType.SystemStatusFuelcell:
            return 'Systemstatus Brennstoffzelle';
        case ErrorType.STMInput:
            return 'STM Eingang';
        case ErrorType.ConnectionError:
            return 'Verbindungsfehler';
/*         case ErrorType.LampError:
            return 'Blinkerfehler'; */
        case ErrorType.Unknown:
            return 'Unbekannt';
        default:
            return 'Unbekannt';
    }
}

export function getErrorTypeSelect(): SelectInput[] {
    return [
        { name: getErrorTypeString(ErrorType.ChannelError), id: 1 },
        { name: getErrorTypeString(ErrorType.PixelError), id: 2 },
        { name: getErrorTypeString(ErrorType.VoltageError), id: 3 },
        { name: getErrorTypeString(ErrorType.FuelWarning), id: 4 },
        { name: getErrorTypeString(ErrorType.SystemStatusFuelcell), id: 5 },
        { name: getErrorTypeString(ErrorType.STMInput), id: 6 },
   /*      { name: getErrorTypeString(ErrorType.LampError), id: 7 }, */
        { name: getErrorTypeString(ErrorType.ConnectionError), id: 8 },
        { name: getErrorTypeString(ErrorType.Unknown), id: 0 },
    ];
}